var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProtect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_3453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8294 0.125C22.2091 3.99983 27.9253 6.01731 33.7669 5.75C34.6174 8.64315 34.8776 11.6777 34.5321 14.6735C34.1866 17.6692 33.2425 20.5649 31.7558 23.1885C30.2691 25.8121 28.2701 28.1101 25.8778 29.9459C23.4854 31.7817 20.7484 33.1179 17.8294 33.875C14.9104 33.1179 12.1734 31.7817 9.78105 29.9459C7.38867 28.1101 5.38973 25.8121 3.90302 23.1885C2.4163 20.5649 1.47215 17.6692 1.12667 14.6735C0.781183 11.6777 1.04142 8.64315 1.8919 5.75C7.73352 6.01731 13.4497 3.99983 17.8294 0.125Z",
    fill: "#38A539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2046 17L15.9546 20.75L23.4546 13.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_3453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.70459)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtect);
export default __webpack_public_path__ + "static/media/icon-protect.c6dfc286b2ee37aa2d3fc98e61672388.svg";
export { ForwardRef as ReactComponent };